import React from 'react';
import { ReactComponent as BitcoinSvg } from 'src/assets/svg/home/bitcoin.svg';
import { ReactComponent as BitcoinMobileSvg } from 'src/assets/svg/home/bitcoin-mobile.svg';
import NetImg from 'src/assets/image/home/net.png';
import NetMobileImg from 'src/assets/image/home/net-mobile.png';
import { Col, Image, Row } from 'antd';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import withLogin from 'src/hoc/login.enhance';
import { isLoginSelector } from 'src/modules/Auth/Auth.selector';
import { BTNPrimary } from 'src/components/Button';
import { isMobile } from 'react-device-detect';
import { Wrapper } from './UpgradeYourTiers.styled';

interface IProps {
    openLoginModal: () => void;
}

function UpgradeYourTiers({ openLoginModal }: IProps & any) {
    const isLogin = useSelector(isLoginSelector);
    const history = useHistory();
    return (
        <Wrapper>
            {isMobile ? (
                <div className="upgrade-mobile">
                    <div className="main-content">
                        <span className="upgrade">Upgrade</span> <span className="your-tier">your Tiers</span>
                    </div>
                    <Row className="box-upgrade-mobile">
                        <Col className="left-upgrade" xs={12} md={12} lg={12}>
                            <div className="hint fs-regular fw-regular">
                                Our Stakers are already enjoying high ROI & rewards from IDO & yield staking program.
                            </div>
                        </Col>
                        <Col className="right" xs={12} md={12} lg={12}>
                            <BitcoinMobileSvg />
                        </Col>
                    </Row>
                    <Image src={NetMobileImg} preview={false} className="net-upgrade-mobile" />
                    <BTNPrimary
                        title="Upgrade"
                        className="btn-upgrade fw-small fw-suppermedium"
                        onClick={() => {
                            if (isLogin) {
                                history.push('/accounts?tab=wallet');
                            } else {
                                openLoginModal();
                            }
                        }}
                    />
                </div>
            ) : (
                <Row className="box-upgrade">
                    <Col
                        className="left-upgrade"
                        xs={24}
                        md={12}
                        lg={12}
                        data-aos="fade-down-right"
                        data-aos-offset="-100"
                        data-aos-easing="ease-in-sine"
                        data-aos-duration="500"
                    >
                        <div className="main-content">
                            <span className="upgrade fs-titlemedium fw-suppermedium">Upgrade </span>
                            <span className="your-tier fs-titlemedium fw-suppermedium">your Tiers</span>
                        </div>
                        <div className="hint fs-regular fw-regular">
                            Our Stakers are already enjoying high ROI & rewards from IDO & yield staking program.
                        </div>
                        <BTNPrimary
                            title="Upgrade"
                            className="btn-upgrade fw-small fw-medium"
                            onClick={() => {
                                if (isLogin) {
                                    history.push('/accounts?tab=wallet');
                                } else {
                                    openLoginModal();
                                }
                            }}
                        />
                    </Col>
                    <Col
                        className="right"
                        xs={24}
                        md={12}
                        lg={12}
                        data-aos="fade-down-left"
                        data-aos-offset="200"
                        data-aos-easing="ease-in-sine"
                        data-aos-duration="500"
                    >
                        <BitcoinSvg />
                    </Col>
                </Row>
            )}
            {!isMobile && <Image src={NetImg} preview={false} className="net-upgrade" />}
        </Wrapper>
    );
}
export default withLogin(UpgradeYourTiers);
